import React from "react";
import "../dashboard/style.css";
import { PageWrapper } from "utility/styled-components";
import { reportId, ctid } from "./config";


const CostAnalyticsDashboard: React.FC = () => {
  const reportUrl = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&autoAuth=true&ctid=${ctid}`;

  return (
    <PageWrapper>
      <iframe title="TDSP Cost Analytics by Model" style={{ width: "100%", height: "85vh", border: 0 }} src={reportUrl} allowFullScreen={true}></iframe>
    </PageWrapper>
  );
};

export default CostAnalyticsDashboard;
